export default {
	er_cover_default_title: 'പ്രകടന അവലോകനം',
	er_page_success_metrics: 'ഈ മാസം എന്ത് മാറി',
	er_page_success_metrics_range: 'ഈ കാലയളവിൽ എന്ത് മാറി',
	er_page_success_metrics_week: 'ഈ ആഴ്ച എന്ത് മാറി',
	er_page_comparison: 'താരതമ്യ സംഗ്രഹം',
	er_page_period_summary: 'മാസ സംഗ്രഹം',
	er_page_period_summary_range: 'കാലയളവ് സംഗ്രഹം',
	er_page_period_summary_week: 'ആഴ്ച സംഗ്രഹം',
	er_page_each_month: 'ഓരോ മാസവും',
	er_page_rooms: 'മുറികൾ',
	er_rooms_note: '{month}-ലെ എല്ലാ മുറികളും, ഉയർന്ന സ്കോർ ആദ്യം.',
	er_page_shift_comparison: 'ഷിഫ്റ്റ് താരതമ്യം',
	er_page_shift_summary: 'ഷിഫ്റ്റ് അനുസരിച്ച്',
	er_page_response_time: 'ശരാശരി പ്രതികരണ സമയം (മിനിറ്റ്)',
	er_page_avg_score: 'അനുഭവ സ്കോർ',
	er_page_complaints_vs_visits: 'പരാതികൾ vs സന്ദർശനങ്ങൾ',
	er_page_performance_trends: 'പ്രകടന പ്രവണതകൾ',
	er_page_complaint_drivers: 'പരാതികളുടെ കാരണങ്ങൾ',
	er_board_working: '{month} അപേക്ഷിച്ച് മെച്ചം',
	er_board_attention: '{month} അപേക്ഷിച്ച് ശ്രദ്ധ വേണം',
	er_board_empty: 'ഈ മാസം ശ്രദ്ധേയമായ മാറ്റങ്ങളില്ല.',
	er_board_empty_range: 'ഈ കാലയളവിൽ ശ്രദ്ധേയമായ മാറ്റങ്ങളില്ല.',
	er_board_empty_week: 'ഈ ആഴ്ച ശ്രദ്ധേയമായ മാറ്റങ്ങളില്ല.',
	er_findings_intro: '{month} താരതമ്യം. ശ്രദ്ധേയമായ മാറ്റങ്ങൾ മാത്രം.',
	er_verdict_improved: 'മെച്ചപ്പെട്ടു',
	er_verdict_watch: 'ശ്രദ്ധ വേണം',
	er_col_metric: 'സൂചകം',
	er_col_avg: 'YTD ശരാ.',
	er_col_lifetime_avg: 'തുടക്കം മുതൽ ശരാ.',
	er_comparison_note: 'YTD ശരാശരി ജനുവരി മുതൽ {month} വരെയുള്ള കണക്കാണ്.',
	er_lifetime_note: 'തുടക്കം മുതൽ എന്നത് ഡാറ്റയുള്ള ആദ്യ ദിവസം മുതൽ {month} വരെയുള്ള മാസ ശരാശരിയാണ്.',
	er_comparison_note_week: 'റിപ്പോർട്ട് ആഴ്ച തിരഞ്ഞെടുത്ത മുൻ ആഴ്ചയുമായി താരതമ്യം ചെയ്യുന്നു.',
	er_period_only_note: 'കണക്കുകൾ {month} മാത്രമാണ്.',
	er_each_month_note: 'തിരഞ്ഞെടുത്ത കാലയളവിലെ ഓരോ മാസവും. ഡാറ്റയില്ലാത്ത മാസം ശൂന്യമായി തുടരും.',
	er_col_inc_dec: 'വർധന / കുറവ്',
	er_col_complaint: 'പരാതി',
	er_col_qty: 'എണ്ണം',
	er_total: 'ആകെ',
	er_metric_avg_score: 'അനുഭവ സ്കോർ',
	er_metric_avg_response_time: 'ശരാശരി പ്രതികരണ സമയം',
	er_metric_cleaner_arrivals: 'ക്ലീനർ വരവുകൾ',
	er_metric_supervisor_inspections: 'സൂപ്പർവൈസർ പരിശോധനകൾ',
	er_metric_complaints_vs_visits_pct: 'പരാതികൾ vs. സന്ദർശനങ്ങൾ (%)',
	er_metric_complaints: 'പരാതികൾ',
	er_metric_customer_visits: 'സന്ദർശനങ്ങൾ',
	er_metric_expired_slas: 'കാലഹരണപ്പെട്ട SLA',
	er_unit_min: 'മിനി',
	er_stat_expected_sla: 'പ്രതീക്ഷിച്ച SLA',
	er_stat_vs_minutes: '{month}-ൽ {value}-നെ അപേക്ഷിച്ച്',
	er_stat_vs_count: '{month}-ൽ {value}-നെ അപേക്ഷിച്ച്',
	er_label_complaints: 'പരാതികൾ',
	er_label_visits: 'സന്ദർശനങ്ങൾ',
	er_label_complaints_per_visits: 'പരാതികൾ / സന്ദർശനങ്ങൾ',
	er_chart_ratio: 'പരാതി-സന്ദർശന അനുപാതം',
	er_chart_ytd_window: 'ജനുവരി മുതൽ {month} വരെ.',
	er_cv_formula: 'ടോയ്‌ലറ്റ് സന്ദർശനങ്ങളാൽ ഹരിച്ച പരാതികൾ, ശതമാനമായി: ({complaints} ÷ {visits}) × 100 = {ratio}% {month}-ൽ.',
	er_export_kpis_title: 'റിപ്പോർട്ടിൽ എന്തൊക്കെ',
	er_export_kpis_desc: 'ഇവയെല്ലാം റിപ്പോർട്ടിലുണ്ട്. വേണ്ടാത്തത് ഓഫ് ചെയ്യുക.',
	er_export_select_all: 'എല്ലാം തിരഞ്ഞെടുക്കുക',
	er_export_clear_all: 'എല്ലാം മായ്ക്കുക',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'റിപ്പോർട്ട് കാലയളവ്',
	er_export_grain: 'റിപ്പോർട്ട്',
	er_export_grain_month: 'മാസം',
	er_export_grain_week: 'ആഴ്ച',
	er_export_week_starts: 'ആഴ്ച ആരംഭിക്കുന്നത്',
	er_export_week_starts_sunday: 'ഞായറാഴ്ച',
	er_export_week_starts_monday: 'തിങ്കളാഴ്ച',
	er_export_report_month: 'റിപ്പോർട്ട് മാസം',
	er_export_from_month: 'മുതൽ',
	er_export_to_month: 'വരെ',
	er_export_period_note_range: 'റിപ്പോർട്ട് ആരംഭം മുതൽ അവസാനം വരെയുള്ള ഓരോ മാസവും കൂട്ടുന്നു. താരതമ്യം ഓണാണെങ്കിൽ അതേ ദൈർഘ്യമുള്ള മുൻ കാലയളവാണ്. വർഷാരംഭ കണക്കുകൾ ഇപ്പോഴും ജനുവരി മുതൽ അവസാന മാസം വരെയാണ്.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'അതേ ദൈർഘ്യമുള്ള മുൻ കാലയളവ്.',
	er_export_report_week: 'റിപ്പോർട്ട് ആഴ്ച',
	er_export_compare_month: 'താരതമ്യം ചെയ്യുക',
	er_export_shift: 'ഷിഫ്റ്റ്',
	er_export_shift_all: 'എല്ലാ ഷിഫ്റ്റുകളും',
	er_export_no_shifts: 'ഈ സൈറ്റിന് സജീവമായ ഷിഫ്റ്റുകൾ ഇല്ല.',
	er_export_render_failed: 'റിപ്പോർട്ട് ശരിയായി തയ്യാറാക്കാൻ കഴിഞ്ഞില്ല, അതിനാൽ അത് ഡൗൺലോഡ് ചെയ്തില്ല. പേജ് പുതുക്കി വീണ്ടും ശ്രമിക്കുക.',
	er_export_comparison: 'താരതമ്യം',
	er_export_include_previous: 'മുൻ കാലയളവ് ഉൾപ്പെടുത്തുക',
	er_export_comparison_on: 'ഓൺ',
	er_export_comparison_off: 'ഓഫ്',
	er_export_no_previous_data: 'ഈ കാലയളവിന് മുമ്പ് ഡാറ്റ ഇല്ല, അതിനാൽ താരതമ്യം ചെയ്യാൻ ഒന്നുമില്ല.',
	er_export_compare_previous: 'കഴിഞ്ഞ മാസം',
	er_export_compare_previous_week: 'കഴിഞ്ഞ ആഴ്ച',
	er_export_compare_last_year: 'കഴിഞ്ഞ വർഷത്തെ അതേ മാസം',
	er_export_no_periods: 'റിപ്പോർട്ട് എക്‌സ്‌പോർട്ട് ചെയ്യാൻ ഈ സൈറ്റിന് ഒരു മാസത്തെ ഡാറ്റയെങ്കിലും വേണം.',
	er_export_no_periods_week: 'റിപ്പോർട്ട് എക്‌സ്‌പോർട്ട് ചെയ്യാൻ ഈ സൈറ്റിന് ഒരാഴ്ച ഡാറ്റയെങ്കിലും വേണം.',
	er_export_period_note: 'ഡാറ്റയുള്ള മാസങ്ങൾ മാത്രമേ കാണിക്കൂ. വർഷാരംഭം മുതലുള്ള കണക്കുകൾ എപ്പോഴും ജനുവരി മുതൽ റിപ്പോർട്ട് മാസം വരെയാണ്.',
	er_export_period_note_week: 'ഡാറ്റയുള്ള ആഴ്ചകൾ മാത്രമേ കാണിക്കൂ. താരതമ്യം എപ്പോഴും മുൻ ആഴ്ചയുമായാണ്.',
	er_export_period_note_single_week: 'ഡാറ്റയുള്ള ആഴ്ചകൾ മാത്രമേ കാണിക്കൂ.',
	er_find_response_time_title: 'ശരാശരി പ്രതികരണ സമയം',
	er_find_response_time_change: '{previous} മിനിറ്റിൽ നിന്ന് {current} ആയി ({change}).',
	er_find_avg_score_title: 'അനുഭവ സ്കോർ',
	er_find_score_eased: '{previous} ൽ നിന്ന് {current} ആയി കുറഞ്ഞു.',
	er_find_score_improved: '{previous} ൽ നിന്ന് {current} ആയി ഉയർന്നു.',
	er_find_score_ytd_inline: 'വർഷാരംഭം മുതലുള്ള ശരാശരി {ytd} ആണ്.',
	er_find_score_ytd_inline_range: 'ജനുവരി മുതൽ {endMonth} വരെയുള്ള ശരാശരിക്ക് തുല്യം ({ytd}).',
	er_find_score_ytd_against: 'വർഷാരംഭം മുതലുള്ള ശരാശരി: {ytd}.',
	er_find_score_ytd_against_range: 'ജനുവരി മുതൽ {endMonth} വരെയുള്ള ശരാശരി: {ytd}.',
	er_find_complaints_ratio_title: 'പരാതി-സന്ദർശന അനുപാതം',
	er_find_complaints_ratio_improved: '{previous} ൽ നിന്ന് {current} ആയി മെച്ചപ്പെട്ടു.',
	er_find_complaints_ratio_rose: '{previous} ൽ നിന്ന് {current} ആയി മാറി.',
	er_nar_cv_year_improved: 'ടോയ്‌ലറ്റ് സന്ദർശനങ്ങളുമായി താരതമ്യം ചെയ്യുമ്പോൾ പരാതികൾ വർഷത്തിൽ {from} മുതൽ {to} ആയി മെച്ചപ്പെട്ടു.',
	er_nar_cv_year_rose: 'ടോയ്‌ലറ്റ് സന്ദർശനങ്ങളുമായി താരതമ്യം ചെയ്യുമ്പോൾ പരാതികൾ വർഷത്തിൽ {from} മുതൽ {to} ആയി ഉയർന്നു.',
	er_nar_cv_moved: 'ടോയ്‌ലറ്റ് സന്ദർശനങ്ങളുമായി താരതമ്യം ചെയ്യുമ്പോൾ പരാതികൾ {previous} മുതൽ {current} ആയി മാറി.',
	er_nar_cv_current: 'ടോയ്‌ലറ്റ് സന്ദർശനങ്ങളുമായി താരതമ്യം ചെയ്യുമ്പോൾ പരാതികൾ {current} ആണ്.',
	er_nar_types_total: 'ആകെ പരാതികൾ {total}.',
	er_nar_types_1: 'പ്രധാന പരാതി: {a} ({ap}%).',
	er_nar_types_2: 'പ്രധാന പരാതി: {a} ({ap}%), തുടർന്ന് {b} ({bp}%).',
	er_nar_types_3: 'പ്രധാന പരാതി: {a} ({ap}%), തുടർന്ന് {b} ({bp}%) ഒപ്പം {c} ({cp}%).',
	er_find_rooms_slowest: 'ഏറ്റവും ദൈർഘ്യമേറിയ പ്രതികരണ സമയമുള്ള മുറികൾ ഈ മാസം: {rooms}.',
	er_find_rooms_slowest_range: 'ഏറ്റവും ദൈർഘ്യമേറിയ പ്രതികരണ സമയമുള്ള മുറികൾ ഈ കാലയളവിൽ: {rooms}.',
	er_find_rooms_slowest_week: 'ഏറ്റവും ദൈർഘ്യമേറിയ പ്രതികരണ സമയമുള്ള മുറികൾ ഈ ആഴ്ച: {rooms}.',
	er_find_rooms_lowest_score: 'ഈ മാസം ഏറ്റവും കുറഞ്ഞ സ്കോർ ഉള്ള മുറികൾ: {rooms}.',
	er_find_rooms_lowest_score_range: 'ഏറ്റവും കുറഞ്ഞ സ്കോറുള്ള മുറികൾ ഈ കാലയളവിൽ: {rooms}.',
	er_find_rooms_lowest_score_week: 'ഈ ആഴ്ച ഏറ്റവും കുറഞ്ഞ സ്കോർ ഉള്ള മുറികൾ: {rooms}.',

	er_find_so_what_ratio: 'മാറ്റത്തിന്റെ ഭൂരിഭാഗവും {rooms} ൽ നിന്നാണ്.',
	er_find_so_what_type: 'പ്രധാന പരാതി: {name} ({percent}%).',
	er_hot_slowest: 'ഏറ്റവും ദൈർഘ്യമേറിയ പ്രതികരണ സമയമുള്ള മുറികൾ',
	er_hot_expired_slas: 'SLA കവിഞ്ഞ മുറികൾ',
	er_hot_ratio: 'പരാതി നിരക്കിൽ ഏറ്റവും വലിയ മാറ്റമുള്ള മുറികൾ',
	er_hot_top_type: '"{name}" പരാതികൾ ഏറ്റവും കൂടുതലുള്ള മുറികൾ',
	er_hot_col_room: 'മുറി',
	er_col_response: 'പ്രതികരണം',
	er_col_cleaners: 'ക്ലീനർമാർ',
	er_col_score: 'സ്കോർ',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'അനുപാതം',
	er_hot_col_change: 'മാറ്റം',
	er_hot_col_count: 'എണ്ണം',
	er_hot_empty: 'ഈ മാസം മുറിതലത്തിൽ ഹൈലൈറ്റുകളില്ല.',
	er_hot_empty_range: 'ഈ കാലയളവിൽ മുറിതലത്തിൽ ഹൈലൈറ്റുകളില്ല.',
	er_hot_empty_week: 'ഈ ആഴ്ച മുറിതലത്തിൽ ഹൈലൈറ്റുകളില്ല.',
	er_cover_highlights: 'ഈ മാസം',
	er_cover_highlights_range: 'ഈ കാലയളവ്',
	er_cover_highlights_week: 'ഈ ആഴ്ച',
	er_cover_score_rose: 'അനുഭവ സ്കോർ ഉയർന്നു.',
	er_cover_score_eased: 'അനുഭവ സ്കോർ താഴ്ന്നു.',
	er_cover_response_improved: 'പ്രതികരണ സമയം മെച്ചപ്പെട്ടു.',
	er_cover_response_slowed: 'പ്രതികരണ സമയം കൂടി.',
	er_cover_ratio_fell: 'സന്ദർശനങ്ങളോടുള്ള പരാതികളുടെ അനുപാതം കുറഞ്ഞു.',
	er_cover_ratio_rose: 'സന്ദർശനങ്ങളോടുള്ള പരാതികളുടെ അനുപാതം ഉയർന്നു.',
	er_export_pdf: 'ഡാഷ്‌ബോർഡ് PDF',
	er_export_executive: 'എക്സിക്യൂട്ടീവ് റിപ്പോർട്ട്',
	'executive-report': 'എക്സിക്യൂട്ടീവ് റിപ്പോർട്ട്',
	er_export_csv: 'CSV',
	er_export_status_title: 'റിപ്പോർട്ട് തയ്യാറാക്കുന്നു',
	er_export_status_fetch: 'കണക്കുകൾ ലോഡ് ചെയ്യുന്നു',
	er_export_status_layout: 'പേജുകൾ ഒരുക്കുന്നു',
	er_export_status_page: 'പേജ് {page} / {total}',
	er_footer_copyright: 'ഈ റിപ്പോർട്ട് BuzzzTech സിസ്റ്റം ഉപയോഗിച്ച് തയ്യാറാക്കിയതാണ്.',
	er_contact_line: 'ചോദ്യങ്ങളുണ്ടോ, അല്ലെങ്കിൽ ഡാറ്റ കൂടുതൽ പരിശോധിക്കണോ? BuzzzTech Customer Success ടീമിനെ ബന്ധപ്പെടുക: {email} അല്ലെങ്കിൽ {phone}.',
};
